<app-register-layout
  [flowMode]="flow$ | async"
  [ngSwitch]="state().currentStep"
  [currentStep]="state().currentStep"
>
  <app-registration-header
    [currentStep]="currentStepIndex() + 1"
    [totalSteps]="totalSteps()"
    [isMobileWebView]="isMobileWebView"
    [hideStepCounter]="state().currentStep === 'create-account'"
  />

  <main>
    <account-creation
      (formSubmitted)="handleAccountCreationSubmit($event)"
      *ngSwitchCase="'create-account'"
      [isMobileWebView]="isMobileWebView"
      [isSSO]="isSSO"
      [ssoEmail]="ssoEmail"
    />

    <app-email-verification
      (nextStep)="goToNextStep()"
      (reEnter)="handleReEnterEmailRequested()"
      *ngSwitchCase="'email-verification'"
      [enrollmentCode]="enrollmentCodeParam() || undefined"
    />

    <app-backup-contact
      (nextStep)="goToNextStep()"
      *ngSwitchCase="'backup-contact'"
      [enrollmentCode]="enrollmentCodeParam() || undefined"
    />

    <app-eligibility-check
      (formSubmitted)="goToNextStep()"
      *ngSwitchCase="'eligibility-check'"
      [registeredEmail]="state().registeredEmail"
      [(isMFAEnforced)]="isMFAEnforced"
      (MFAEnforcedChange)="isMFAEnforced = $event"
      [enrollmentCode]="enrollmentCodeParam() || undefined"
    />

    <app-two-step-verification
      (nextStep)="goToNextStep()"
      *ngSwitchCase="'mfa-setup'"
      [enrollmentCode]="enrollmentCodeParam() || undefined"
    />
  </main>
</app-register-layout>
